import { render, staticRenderFns } from "./LogGateEvent.vue?vue&type=template&id=0b9133dc&scoped=true&"
import script from "./LogGateEvent.vue?vue&type=script&lang=js&"
export * from "./LogGateEvent.vue?vue&type=script&lang=js&"
import style0 from "./LogGateEvent.vue?vue&type=style&index=0&id=0b9133dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9133dc",
  null
  
)

export default component.exports